var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{staticClass:"mr-2",attrs:{"small":"","label":"","color":_vm.labelColor,"text-color":"white"}},[_vm._v("\n  "+_vm._s(_vm.labelText)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }